var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPVerifyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.335,
    cy: 13.335,
    r: 13.335,
    fill: "#4E26A3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 14.5776L7.30845 13.0752L10.6305 16.8885L19.5037 6.7002L20.8122 8.20257L10.6296 19.8933L6 14.5776Z",
    fill: "#D0D0D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPVerifyIcon);
export default __webpack_public_path__ + "static/media/p_verify_icon.a48fa2626e1b65c12cbb329bf195f228.svg";
export { ForwardRef as ReactComponent };